import _Field from "redux-form/es/Field";
import React from 'react';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import { RectangleInput } from 'swag-client-common/components/inputs/rectangle-input-v2';
import { required, email as emailValidation } from 'swag-client-common/utils/redux-form-validators';
import classes from './time-over-for-limited-edition-form.scss';
export const TimeOverForLimitedEditionForm = ({
  onClose,
  onSubscribe,
  handleSubmit
}) => {
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.textClassName
  }, /*#__PURE__*/React.createElement("p", null, "This product is no longer available for purchase. Be sure to be on the lookout for future limited edition offers. You can subscribe below to find out when we release new limited edition products.")), /*#__PURE__*/React.createElement(_Field, {
    component: RectangleInput,
    wrapperClassName: classes.formInputWrapper,
    className: classes.formInput,
    type: "text",
    name: "email",
    autoComplete: "email",
    placeholder: "Enter your email",
    validate: [required, emailValidation]
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonsContainer
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.button,
    label: "Browse products",
    type: "defaultGrey",
    onClick: onClose,
    dataButton: "BrowseProducts"
  }, "Browse Products"), /*#__PURE__*/React.createElement(Button, {
    className: classnames(classes.button, classes.subscribe),
    label: "Subscribe",
    type: "defaultGrey",
    dataButton: "Subscribe",
    onClick: handleSubmit(onSubscribe)
  }, "Subscribe")));
};